module.exports = __webpack_public_path__ + "static/media/SPG-BNB.641bb73e.svg";